/**
 * @param {object} params
 * @param {import("../../types/Configuration").Configuration} params.configuration
 * @param {import("../../types/Payment").PaymentType} [params.type]
 * @param {boolean} [params.onlyAccount]
 * @param {boolean} [params.onlyAdmin]
 *
 * @returns {Object<string, import("../../types/Configuration").ConfigurationPaymentMethod>}
 */
export default function getPaymentsMethodsForType({
  configuration,
  type,
  onlyAccount = false,
  onlyAdmin = false,
}) {
  const compatibleMethods = Object.entries(
    configuration.globals?.payments?.methods ?? {},
  )
    .filter(([key, method]) => (type ? method[`for_${type}`] : true))
    .reduce((acc, [key, method]) => {
      // bail if we only want account methods
      if (onlyAccount && !method.account) {
        return acc;
      }
      // bail if we only want admin methods
      if (onlyAdmin && !method.admin) {
        return acc;
      }
      acc[key] = method;
      return acc;
    }, {});
  return compatibleMethods;
}
